/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

// components
import { Grid } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

// styles
import { StyledButton } from '../../../assets/styles/styles';
// assets

const CardStatutes = (props) => {
  const { isMobileDevice, disabled, onDownloadContract } = props;

  return (
    <SimpleCard
      contentHeader={
        <section className="d-flex justify-content-between w-100">
          <article className="d-flex flex-column">
            <h2 className="text-color-38">Estatutos Coopeuch</h2>
            <p className="text-color-38">
              Los estatutos no son parte de los contratos, pero es importante que los leas.
            </p>
          </article>
          <StyledButton
            className="w-auto"
            disabled={false}
            onClick={() => onDownloadContract('ESTATUTOS_COOPEUCH', 'GENERICO', 'ENR3')}
            prefix="line-download-2"
            variant="text"
            sizeIcon="18"
          >
            {!isMobileDevice && 'Descargar'}
          </StyledButton>
        </section>
      }
      disabled={disabled}
    >
      <Grid className="m-0 padding-16 p-md-6 bg-color-f6">
        <p className="font-size-18 line-height-24 font-weight-bold">Estatutos Coopeuch</p>
        <ul className="margin-top-4 vineta-circle">
          <li className="font-size-14 line-height-20 text-color-38">
            En los Estatutos Coopeuch, encontrarás más acerca de Coopeuch y tus derechos y deberes
            como nuevo socio.
          </li>
        </ul>
      </Grid>
    </SimpleCard>
  );
};

CardStatutes.defaultProps = {
  isMobileDevice: false,
  onDownloadContract: () => null,
};

CardStatutes.propTypes = {
  isMobileDevice: PropTypes.bool,
  onDownloadContract: PropTypes.func,
};

export default CardStatutes;
